import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "recallmines";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        speedrecall: true,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.speedrecall = storeddata.speedrecall;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      state: { taskConfig },
    } = this;

    return (
      <TaskDialog heading={"Recall Miners"}>
        <TaskCheckBox
          label={" Use Speedups to speed recall to home cities."}
          param={"speedrecall"}
          taskConfig={taskConfig}
          setValue={setValue}
        />
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Recall Miners"}
        />
      </TaskDialog>
    );
  };
}
